// features/services/ServicesSection.jsx
import { services } from "./services.data";
import ServiceCard from "./ServiceCard";
import { Link } from "react-router-dom";

export default function ServicesSection({ previewCount = null, showViewAll = false }) {
  const visibleServices = previewCount ? services.slice(0, previewCount) : services;

  return (
    <section id="services" className="mx-auto w-full max-w-6xl px-6 py-20">
      <div className="mb-12 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#5481be] dark:text-[#89abe0]">
            რა შეგვიძლია
          </p>
          <h2 className="mt-3 text-3xl font-bold text-[#0f2748] dark:text-[#e5efff] md:text-4xl">
            ჩვენი სერვისები
          </h2>
        </div>
        <p className="max-w-xl text-[#4f6587] dark:text-[#b5c9e8]">
          მაღალი სტანდარტის სანტექნიკური მომსახურება საცხოვრებელი და კომერციული
          ობიექტებისთვის, სწრაფი რეაგირებით და სუფთა შესრულებით.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        {visibleServices.map((service, index) => (
          <ServiceCard key={service.id} service={service} index={index} />
        ))}
      </div>

      {showViewAll && (
        <div className="mt-8 text-center">
          <Link
            to="/services"
            className="inline-flex rounded-2xl bg-[#0f3d7a] px-7 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-[#1452a3] dark:bg-[#284c7f] dark:hover:bg-[#3561a0]"
          >
            ყველა სერვისის ნახვა
          </Link>
        </div>
      )}
    </section>
  );
}
